// eslint-disable-next-line max-classes-per-file
export enum eSourceState {
    PUBLISHED = 1, // From artifact service
    DRAFT = 2 // From user store
}

export class SourceState {
    public state: number = 0;
}

export class SourceMarker {
    private constructor() { }

    public static markPublished(sourceState?: SourceState): SourceState {
        return SourceMarker.mark(eSourceState.PUBLISHED, sourceState, false);
    }

    public static markDraft(sourceState?: SourceState): SourceState {
        return SourceMarker.mark(eSourceState.DRAFT, sourceState, false);
    }

    public static isPublished(sourceState: SourceState): boolean {
        return SourceMarker.isMarked(sourceState, eSourceState.PUBLISHED);
    }

    public static isDraft(sourceState: SourceState): boolean {
        return SourceMarker.isMarked(sourceState, eSourceState.DRAFT);
    }

    private static mark(state: eSourceState, sourceState?: SourceState, erase?: boolean): SourceState {
        if (!sourceState) {
            sourceState = new SourceState();
        }

        if (!erase) {
            // eslint-disable-next-line no-bitwise
            sourceState.state |= state;
        } else {
            sourceState.state = state;
        }
        return sourceState;
    }

    private static isMarked(sourceState: SourceState, state: eSourceState): boolean {
        // eslint-disable-next-line no-bitwise
        return sourceState ? ((sourceState.state & state) === state) : false;
    }
}
